import {
  Alert,
  AlertIcon,
  Button,
  FormControl,
  FormLabel,
  ModalBody,
  ModalFooter,
  Stack,
} from "@chakra-ui/react";
import React from "react";
import { Select } from "chakra-react-select"
import useLinkToolUsers from "../../Tools/useLinkToolUsers";
import useTools from "../../Tools/useTools";
export default function ToolSelectLlm({ onClose, nodeForm, onSubmit, onBack }) {
  const { setValue, watch } = nodeForm.form;
  const { data = {} } = watch();
  const { toolsList, status } = useTools();
  const toolOptions = toolsList.map((tool) => ({
    value: tool.id,
    label: tool.name,
  }));
  const selectedToolOption = toolOptions.find(
    (toolOption) => toolOption.value === data?.tool_id
  );
  const { linkToolUsers, toolUserStatus = status } = useLinkToolUsers({
    tool_id: data?.tool_id,
  });
  const toolConfigOptions = linkToolUsers.map((linkToolUserOption) => ({
    value: linkToolUserOption.id,
    label: linkToolUserOption.name,
  }));
  const selectedToolConfigMap = (data?.tool_users || []).reduce(
    (prev, current) => {
      prev[current] = true;
      return prev;
    },
    {}
  );

  const isLLmResponse = data?.response?.type === "llm";

  return (
    <form onSubmit={(e) => { e.preventDefault(); nodeForm.form.handleSubmit(onSubmit)(); }}>
      <ModalBody>
        <Stack spacing={2}>
          <Alert status="info">
            <AlertIcon />
            Connect any Tool to the LLM request to invoke action based on the
            conversation.
          </Alert>
          <FormControl>
            <FormLabel>Tool</FormLabel>
            <Select
              options={toolOptions}
              onChange={({ value }) => {
                setValue("data.tool_id", value);
              }}
              value={selectedToolOption}
              isDisabled={!isLLmResponse}
              isLoading={status === "loading"}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Tool configs</FormLabel>
            <Select
              options={toolConfigOptions}
              isMulti
              value={toolConfigOptions.filter(
                (toolConfigOption) =>
                  toolConfigOption.value in selectedToolConfigMap
              )}
              onChange={(selectedOptions) => {
                setValue(
                  "data.tool_users",
                  selectedOptions.map((selectedOption) => selectedOption.value)
                );
              }}
              isDisabled={!isLLmResponse}
              isLoading={toolUserStatus === "loading"}
            />
          </FormControl>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={onBack}>
          Back
        </Button>
        <Button type="button" onClick={() => nodeForm.form.handleSubmit(onSubmit)()} colorScheme="yellow">
          Next
        </Button>
      </ModalFooter>
    </form>
  );
}
